var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shells"},[_c('div',{staticClass:"filter-view"},[_c('filterMenu')],1),_c('div',{staticClass:"content"},[_c('div',{staticClass:"top-nav"},[_c('div',{staticClass:"nav-lf"},[_c('MusicType',{attrs:{"width":100,"tabsList":_vm.tabsList,"dropdownList":_vm.dropdownList}})],1)]),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }